import { AutogenModelArCallHistory, AutogenRowArCallHistory } from "./autogen/AutogenModelArCallHistory";

export class ModelArCallHistory extends AutogenModelArCallHistory<RowArCallHistory> {
	constructor() {
		super(RowArCallHistory);
	}
}

export class RowArCallHistory extends AutogenRowArCallHistory {
}